<template>
    <div :ref="ref" class="j-lottie-wrap" />
</template>

<script>
import axios from 'axios'
import lottie from 'lottie-web'
import { web } from '@/config'

export default {
  name: 'JLottie',
  props: {
    name: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      lottie: null
    }
  },
  computed: {
    ref () {
      return `j_lottie_${parseInt(Math.random() * 100)}_${Date.now()}`
    }
  },
  created () {
    this.initLottie()
  },
  methods: {
    play () {
      this.lottie.play()
    },
    pause () {
      this.lottie.pause()
    },
    async initLottie () {
      if (!this.name) return
      const { data } = await axios.request({
          method: 'get',
          url: `${web}/lottie/${this.name}/data.json`,
          notProcessed: true // axios不统一处理请求返回操作
      }).catch(err => {
        console.error(`name:${this.name}; message: ${err.message}; 请检查${this.name}静态目录是否存在`)
      })
      if (!data) return
      // data.w = window.innerWidth
      this.lottie = lottie.loadAnimation({
        container: this.$refs[this.ref],
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: data,
        assetsPath: `/lottie/${this.name}/images/`
      })
    }
  }
}
</script>

<style scoped lang="scss">
    .j-lottie-wrap {
        width: 100%;
        height: 100%;
        &:empty {
            background-color: #F2F6FC;
        }
    }
</style>
